angular.module('CarsSaraBo').controller('PointsOfSaleController', ['$scope', '$routeParams', '$location', 'PointOfSaleService', 'PointOfSaleServiceAll','$filter', 'GAService',
                                          function($scope, $routeParams,$location, pointOfSaleService, pointOfSaleServiceAll,$filter, gaService) {
	
	$scope.initialize = function() {
		$scope.validations={};
		$scope.pointsOfSale= [];
		$scope.config = {
				itemsPerPage:10,
				currentPage:1,
				numPages:0,
				totalItems:0
			}
		$scope.pagePointOfSaleList = [];
		pointOfSaleService.resource.query({companyOid: $routeParams.companyOid, fields:"name,contactName,locationName,phone" }, function(pointsOfSale) {
			$scope.hideProgressBar();
			$scope.validations.pointsOfSale=true;
			$scope.pointsOfSale = pointsOfSale;
			$scope.config.totalItems = $scope.pointsOfSale.length;
			$scope.config.numPages=Math.floor($scope.pointsOfSale.length/$scope.config.itemsPerPage);
			$scope.changePage();
		});
		$scope.editablePointOfSale = $scope.loggedUserAllowed('PERM_POS_CREATE') ||  $scope.loggedUserAllowed('PERM_POS_EDIT') ||  $scope.loggedUserAllowed('PERM_POS_DELETE');
		$scope.order = {field : "" , desc : false};
	}
	
	$scope.edit = function(pointOfSale) {
		$location.path("/company/" +  $routeParams.companyOid + "/pointsOfSale/" + pointOfSale.oid)
	}
	
	$scope.create = function() {
		$location.path("/company/" +  $routeParams.companyOid + "/pointsOfSale/add")
	}

	$scope.goToAdditionals = function() {
        $location.path("/company/" +  $routeParams.companyOid + "/pickupPoint")
    }
	
	$scope.changePage = function(){
		var startItem = $scope.config.itemsPerPage*$scope.config.currentPage;
		$scope.pagePointOfSaleList = $scope.pointsOfSale.slice(startItem-$scope.config.itemsPerPage, startItem);
	}
	
	$scope.sort = function(fieldName, desc){
		
		if($scope.order.field != fieldName){
			$scope.order.field = fieldName;
			$scope.order.desc = desc != undefined ? desc : false;
		} else {
			$scope.order.desc = desc != undefined ? desc : !$scope.order.desc;
		}
		
		$scope.pointsOfSale = $filter('orderBy')($scope.pointsOfSale, $scope.order.field, $scope.order.desc);
		
		$scope.goToFirstPage();
	}
	
	$scope.goToFirstPage = function (){
		$scope.currentPage = 1;
		$scope.changePage();
	}
	
	$scope.itemsToRemove = function() {
		return _.filter($scope.pointsOfSale, {"selected" : true});
	}
	
	$scope.remove = function() {
		var oids = [];
		var toRemove = $scope.itemsToRemove();
		angular.forEach(toRemove, function(point) {oids.push(point.oid)});

        countToRemove = toRemove.length;
        
        if(countToRemove > 0) {
    		$scope.showModal("REMOVE_ALERT_TITLE", "REMOVE_ALERT_DESCRIPTION", function() {
    			pointOfSaleServiceAll.remove({companyOid: $routeParams.companyOid, oids: oids})
    			.$promise.then( function() {
    					gaService.notify("Autos_sucursales", "eliminar_sucursal", [countToRemove]);
    			        $scope.initialize();	
    			    },function(errorResponse) { 
    					$scope.notifyErrorDetailByCodes(errorResponse); 
    				}
    			);
    		});
        }
	}
	
	$scope.initialize();
	
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/pointsofsale_controller.js
// module id = 906
// module chunks = 3